<template lang="pug">
  v-toolbar(dark dense fixed).sunset-admin-app-bar
    v-toolbar-title LionDesk Sunset Admin
    v-spacer
    v-btn(text @click="handleLogout") Sign out
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SunsetAdminAppBar',
  methods: {
    ...mapActions('sunsetAdmin', [
      'logout',
    ]),
    handleLogout() {
      this.logout();
      this.$router.replace('/sunset-admin/login');
    },
  },
};
</script>

<style lang="scss">
.sunset-admin-app-bar {
  .v-toolbar__content {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    width: 100% !important;
    
    .v-toolbar__title {
      font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      margin-right: auto !important;
      flex-shrink: 0 !important;
    }
    
    .v-spacer {
      flex: 1 1 auto !important;
      min-width: 0 !important;
    }
    
    .v-btn {
      margin-left: auto !important;
      flex-shrink: 0 !important;
      border-radius: 6px !important;
      border: 1px solid #ffffff !important;
      padding: 4px 22px !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      height: 28px !important;
      text-transform: capitalize !important;
      line-height: 18px !important;
      font-family: -apple-system, "system-ui", "Segoe UI", Roboto, "Open Sans", Ubuntu, "Droid Sans", "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
      color: #ffffff !important;
      background-color: transparent !important;
      transition: all 0.3s ease !important;
      &:hover {
        background-color: #ffffff !important;
        color: #000000 !important;
      }
      &:active {
        transform: translateY(0) !important;
      }
    }
  }
}
</style>